import { useEffect, useState } from "react";
import { AccountantProvider, useAccountant } from "./AccountantContext";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import JobInvoiceTab from "./JobInvoiceTab";
import PropertyPricingTab from "./PropertyPricingTab";
import WorkOrderTab from "./WorkOrderTab";
import MyobConnectionTab from "./MyobConnectionTab";
import { getAllowedRegions } from "@/service/PricingService";
import { getProfileList, getBusinessesAndAccounts } from "@/service/MyobService";
import {Navigate} from "react-router-dom";

const TAB_MAP = ['job-invoices', 'property-pricing', 'work-order', 'myob-connection'];

function AccountantInner() {
    const [, dispatch] = useAccountant();

    const params = new URLSearchParams(window.location.search);
    const defaultTabName = params.get('tab') || 'job-invoices';
    const defaultIndex = Math.max(0, TAB_MAP.indexOf(defaultTabName));
    const [tabIndex, setTabIndex] = useState(defaultIndex);

    useEffect(() => {
        getAllowedRegions()
            .then(res => { if (!res.ok) throw new Error('Failed to load regions'); return res.json(); })
            .then(regions => {
                if (regions && regions.length > 0) {
                    dispatch({ type: 'SET_REGION', payload: regions[0] });
                    dispatch({ type: 'SET_ALL_REGIONS', payload: regions });
                }
            })
            .catch(err => {
                dispatch({ type: 'SET_NOTIFICATION', payload: { message: err.message, isSuccess: false } });
            });

        dispatch({ type: 'SET_LOADING', payload: true });
        getProfileList()
            .then(res => { if (!res.ok) throw new Error('Failed to load MYOB profiles'); return res.json(); })
            .then(profiles => {
                dispatch({ type: 'SET_MYOB_PROFILES', payload: profiles });
                dispatch({ type: 'SET_LOADING', payload: false });
            })
            .catch(err => {
                dispatch({ type: 'SET_LOADING', payload: false });
                dispatch({ type: 'SET_NOTIFICATION', payload: { message: err.message, isSuccess: false } });
            });

        getBusinessesAndAccounts('false')
            .then(res => { if (!res.ok) throw new Error('Failed to load businesses'); return res.json(); })
            .then(data => {
                dispatch({ type: 'SET_BUSINESSES_ACCOUNTS', payload: data });
            })
            .catch(err => {
                dispatch({ type: 'SET_NOTIFICATION', payload: { message: err.message, isSuccess: false } });
            });
    }, [dispatch]);

    const [state] = useAccountant();

    useEffect(() => {
        if (state.notification) {
            const timer = setTimeout(() => {
                dispatch({ type: 'SET_NOTIFICATION', payload: null });
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [state.notification, dispatch]);

    return (
        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
            <Tabs
                value={tabIndex}
                onChange={(_, v) => setTabIndex(v)}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab label="Job Invoices" sx={{ textTransform: 'none' }} />
                <Tab label="Property Pricing" sx={{ textTransform: 'none' }} />
                <Tab label="Work Order" sx={{ textTransform: 'none' }} />
                <Tab label="MyOB Connection" sx={{ textTransform: 'none' }} />
            </Tabs>
            <Box sx={{ pt: 0 }}>
                {tabIndex === 0 && <JobInvoiceTab />}
                {tabIndex === 1 && <PropertyPricingTab />}
                {tabIndex === 2 && <WorkOrderTab />}
                {tabIndex === 3 && <MyobConnectionTab />}
            </Box>
        </Box>
    );
}

export default function AccountantPage() {
    if (new URLSearchParams(window.location.search).get('tab') === 'agency-defaults') {
        return <Navigate to="/manage-user?role=AGENT" replace />;
    }
    return (
        <AccountantProvider>
            <AccountantInner />
        </AccountantProvider>
    );
}
